<template>
  <div>
    <div class="hezuohuoban">
            <!--top-->
            <div class="top">
                <!--nav-->
                   <Nav></Nav>           
                <!--nav-end-->

                <!--banner-->
                <div class="banner">
                                        <div class="layui-carousel" id="test10">
                        <div class="layui-cen" carousel-item="">
                                                        <div>
                                                                <img src="@s/data/uploads/20180816/b1c62eca7e91f5be6be832f94a763217.jpg">                             </div>
                                                    </div>
                    </div>

                </div>
                <!--banner-end-->
            </div>
            <!--top-end-->

            <!--xinwen-center-->
            <div class="xinwen-center">
                <div class="layui-tab" v-if="nav">
                    <div class="layui-tab-a">
                                                <ul class="layui-tab-title">
                                                            <li :class="{'layui-this': tab==i }" v-for="(item,i) in nav[3].children.slice(0, nav[3].children.length -1)" :key="i">{{item.module}}</li>
                                                            <li :class="{'layui-this': tab== nav[3].children.length-1 }">IP礼品</li>
                                                    </ul>
                    </div>
                    <div class="layui-tab-content">
                            <div class="about women-cen layui-tab-item" v-for="(item,i) in nav[3].children.slice(0, nav[3].children.length -1)" :key="item.code" :class="{'layui-show': tab==i }">
                                <div v-if="introduction[item.code]" v-html="introduction[item.code].introduction"></div>
                            </div>
                                                   
                                                    <div class="about women-cen layui-tab-item"  :class="{'layui-show': tab==nav[3].children.length-1 }">
                                                        <div v-html="intro4.introduction"></div>
                               
                               
                                                              <div class="lipin-footer">
                                <div class="lipin-f-t">
                                    <img src="@/static/skin/web/img/lipin/lipin-footer.png" />
                                </div>
                                <div class="lipin-f-f" id="news_list">
                                                                        <div v-for="(item,i) in giftList" :key="i">
                                        <a :href="'/detail?gift=1&id='+item.id"> <img :src="item.image" /></a>
                                        <h5><a :href="'/detail?gift=1&id='+item.id">{{item.name}}</a></h5>
                                        <p>
                                            <a :href="'/detail?gift=1&id='+item.id">{{item.describe}}</a>
                                        </p>
                                    </div>
                                                                    
                                                                    </div>
                                <div class="sy-footer">
                                    <div id="g" class="duo" data-flag="1" data-page="1" style="cursor:pointer;">查看更多</div>
                                </div>
                            </div>
                            </div>
                                        </div>
                </div>
            </div>
            <!--xinwen-center-end-->

            <!--footer-->
             <Footer></Footer>
            <!--footer-end-->

        </div>
        <Backtop></Backtop>

  </div>
</template>

<script>
import Nav from '@c/Main/Nav/index.vue'
import Footer from '@c/Main/Footer/index.vue'
import Backtop from '@c/Main/Backtop/index.vue'
import { configQuery } from '@/Apis/functions/user'
export default {
    name: "ecological",
    components: { Nav, Footer, Backtop },
    data(){
        return {
            tab: this.$route.params.tab || 0,
            nav: this.$store.state.menuBar,
            intro4:'',
            giftList:[],
            limit:6,
            offset:0,
            introduction: {}
        }
    },
    watch:{
        '$store.state.menuBar'(val){
            this.nav = val
            this.$nextTick(() => {
                this.initData()
                layui.use('element', function() {
                    var $ = layui.jquery,
                        element = layui.element; //Tab的切换功能，切换事件监听等，需要依赖element模块
                })
            })
        }
    },
    methods:{
        initData(){
            this.nav && this.nav[3].children.filter(item => item.code!='0404').forEach(item => {
                configQuery({
                    merchantId: "dwj",
                    code: item.code,
                }).then((result) => {
                    if (result.status == 200) {
                    this.$set(this.introduction,item.code,result.data)
                    }
                });
            })
        },
        getGiftList(page,fn){
            configQuery({
                merchantId:'dwj',
                code:'040402',
                offset:(page-1) * this.limit,
                limit:this.limit
            }).then(result => {
                if (result.status == 200) {
                    this.giftList = this.giftList.concat(result.data)
                    if(result.data.length < this.limit){
                        $('#g').attr('data-flag',0).html('没有更多了！');
                    }
                    fn && fn()
                }
            })
        }
    },
    created(){
        configQuery({
           merchantId:'dwj',
           code:'040401' 
        }).then(result => {
            if (result.status == 200) {
                this.intro4 = result.data
            }
        })    
        this.getGiftList(1)


        
    },
    mounted(){
        if(this.nav){
            this.initData()
                layui.use('element', function() {
                var $ = layui.jquery,
                    element = layui.element; //Tab的切换功能，切换事件监听等，需要依赖element模块
            })
        }
      
        layui.use(['carousel', 'form'], function() {
            var carousel = layui.carousel
            //鍥剧墖杞挱
            carousel.render({
                elem: '#test10',
                width: '100%',
                height: '6.70rem',
                interval: 5000
            });
        })
         var _this = this
        $('.duo').click(function() {
            var page = $(this).attr('data-page');
            var flag = $(this).attr('data-flag');
            if(flag==1) {
                page++;
                $(this).attr('data-page',page);
                var index = layer.load();
                _this.getGiftList(page,() => {
                    layer.close(index);
                })
            }
        });
    }
}
</script>
<style>
@import '~@/static/skin/web/css/qixia.css';
@import '~@/static/skin/web/css/erji.css';
@import '~@/static/skin/web/css/lipin.css';
</style>